import * as React from "react";
import { Formik, Form, Field } from "formik";
import "../../css/generic01.css";
import * as Yup from "yup";
import { IRegister } from "../../interfaces/IRegister";
import {
  Accordion,
  Alert,
  Button,
  Card,
  Form as Frm,
  Modal,
  Tab,
  Table,
  Tabs,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import IPerfilesMenu from "../../interfaces/IPerfilesMenu";

import { IPerfil } from "../../interfaces/Catalogos/IPerfiles";
// import PerfilesMenuServices from '../../Services/Catalogos/PerfilesMenu.Services'
import PerfilesMenuServices from "../../Services/Catalogos/PerfilesMenu.Services";
// import ClientesServices from '../../Services/Catalogos/Clientes.Services'
import usuariosServices from "../../Services/Catalogos/Usuarios.Services";
import MenuUsuario from "../MenuUsuario/MenuUsuario";
// import IClientes from '../../Interfaces/Catalogos/IClientes'
import DTOUsuarioCliente from "../../DTO/DTOUsuarioCliente";
// import ITransportistas from '../../Interfaces/Catalogos/ITransportitas'
// import IProveedores from '../../Interfaces/Catalogos/IProveedores'
// import DTOasignaClienteProveedor from '../../DTO/DTOasignaClienteProveedor'
// import DTOClienteTransportista from '../../DTO/DTOClienteTransportita'
import ITokenInfo from "../../interfaces/Utils/ITokenInfo";
import { UserList } from "./UserList/UserList";
import DTOUsuariosShort from "../../DTO/DTOUsuariosShort";
import DTOClonarUsuario from "../../DTO/DTOClonarUsuario";
import { AdmonPerfiles } from "./admonPerfiles/AdmonPerfiles";
import { Form as FormCtrl } from "react-bootstrap";
import Supervisor from "../Catalogos/CatEmpleados/DTO/Supervisor";
import ListarSupervisoresYMovimientos from "./ListarSupervisoresYMovimientos";
import NominaServices from "../../Services/Catalogos/Nomina"
import AdministrarNomina from "./UserList/AministrarNomita";
interface IProps { }

const SignupSchema = Yup.object().shape({
  usuario: Yup.string()
    .min(6, "Usuario demasiado corto")
    .max(50, "Usuario demasiado largo")
    .required("Requerido"),
  nombre: Yup.string()
    .min(6, "Nombre de usuario demasiado corto")
    .max(100, "Nombre de usuario demasiado largo")
    .required("Requerido"),
  contrasena: Yup.string()
    .min(6, "Contraseña demasiado corta")
    .max(50, "Contraseña demasiado larga"),
  correo: Yup.string().email("Correo invalido").required("Requirido"),
});

export default function Register(props: IProps) {
  const [UserId, setUserId] = useState(() => {
    const stickyValue = window.localStorage.getItem("UserId");
    return stickyValue !== null ? JSON.parse(stickyValue) : 0;
  });
  const [showDialog, setShowDialog] = React.useState(false);
  const [modalUserList, setModalUserList] = React.useState(false);
  const [modalAdmonPerfiles, setmodalAdmonPerfiles] = React.useState(false);
  const [msgDialog, setmsgDialog] = React.useState("");
  const [Asignaciones, setAsignacion] = useState(false);
  const [IdUsuario, setIdUsuario] = useState(0);
  const [Usuario, setUsuario] = useState("");
  const [Nombre, setNombre] = useState("");
  const [Contrasena, setContrasena] = useState("");
  const [Correo, setCorreo] = useState("");
  const [TipoUsuario, setTipoUsuario] = useState(2);
  const [Activo, setActivo] = useState(1);
  const [FechaAlta, setFechaAlta] = useState("");
  const [UsuarioAlta, setUsuarioAlta] = useState(0);
  const [FechaModifico, setFechaModifico] = useState("");
  const [UsuarioModifico, setUsuarioModifico] = useState(0);
  const [FechaElimino, setFechaElimino] = useState("");
  const [UsuarioElimino, setUsuarioElimino] = useState(0);
  const [MotivoElimino, setMotivoelimino] = useState("");
  const [IdModulo, setIdModulo] = useState(0);
  const [Dept, setDept] = useState(0);
  const [TMercancia, setTMercancia] = useState(0);
  const [FechaUltimaVisita, setFechaUltimaVisita] = useState("");
  const [Visitas, setVisitas] = useState(0);
  const [Internos, setInternos] = useState(0);
  const [PermisoEspecial, setPermisoEspecial] = useState(0);
  const [EstadoConfiguracion, setEstadoConfiguracion] = useState(0);
  const [FechaValidacionConf, setFechaValidacionConf] = useState("");
  const [RealizoEncuesta, setRealizoEncuesta] = useState("");
  const [EncuestaActiva, setEncuestaActiva] = useState(0);
  const [FechaLimiteEncuesta, setFechaLimiteEnuesta] = useState("");
  const [CodigoAccesoM, setCodigoAccesoM] = useState("");
  const [TokenAccesoM, setTokenAccesoM] = useState("");
  const [DeviceToken, setDeviceToken] = useState("");
  const [IdPerfil, setIdPerfil] = useState(0);
  const [NumEmpleado, setNumEmpleado] = useState("");
  const [supervisores, setSupervisores] = useState<Supervisor[]>([]);
  const [soloLecturaNomina, setSoloLecturaNomina] = useState(false);
 

  const [IdSupervisor, setIdSupervisor] = useState(0);
  const [user2Clone, setUser2Clone] = React.useState(0);
  const [perfiles, setPerfiles] = useState<IPerfil[]>([
    {
      id: 0,
      perfil: "-SELECCIONE-",
    },
  ]);
  // const [clientes, setClientes] = useState<IClientes[]>([])
  // const [transportistas, setTransportistas] = useState<ITransportistas[]>([])
  // const [proveedores, setProveedores] = useState<IProveedores[]>([])
  const [comboUsuarios, setcomboUsuarios] = useState<DTOUsuariosShort[]>([]);
  const [toastPerfil, setToastPerfil] = useState(false);
  const [UsuariosPerfilesMenu, setUsuariosPerfilesMenu] =
    useState<IPerfilesMenu[]>();
  const [perfilActual, setPerfilActual] = useState<IPerfilesMenu[]>();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [usuarioDestino, setUsuarioDestino] = useState("");
  const [Search, setSearch] = useState("");
  var initialValues: IRegister = {
    id: IdUsuario,
    usuario: Usuario,
    nombre: Nombre,
    contrasena: Contrasena,
    correo: Correo,
    tipoUsuario: TipoUsuario,
    activo: Activo,
    fechaAlta: currentDate(),
    usuarioAlta: IdUsuario,
    fechaModifico: currentDate(),
    usuarioModifico: UsuarioModifico,
    fechaElimino: FechaElimino,
    usuarioElimino: 0,
    motivoElimino: MotivoElimino,
    idModulo: IdModulo,
    dept: Dept,
    tmercancia: TMercancia,
    fechaUltimaVisita: FechaUltimaVisita,
    visitas: Visitas,
    internos: Internos,
    permisoEspecial: PermisoEspecial,
    estadoConfiguracion: EstadoConfiguracion,
    fechaValidacionConf: FechaValidacionConf,
    realizoEncuesta: RealizoEncuesta,
    encuestaActiva: EncuestaActiva,
    fechaLimiteEncuesta: FechaLimiteEncuesta,
    codigoAccesoM: CodigoAccesoM,
    tokenAccesoM: TokenAccesoM,
    deviceToken: DeviceToken,
    idPerfil: IdPerfil,
    numEmpleado: NumEmpleado,
    idSupervisor: IdSupervisor,
  };

  const initialValuesPerfiles: IPerfil = {
    id: IdPerfil,
    perfil: "",
  };


  
  


  function getUsuario() {
    const item = localStorage.getItem("tokenInfo");
    let Usr = "";
    if (item) {
      const registro: ITokenInfo = JSON.parse(item);
      Usr = registro.Usuario;
    }
    return Usr;
  }

  useEffect(() => {
    usuariosServices
      .getAllSupervisor()
      .then((response) => {
        setSupervisores(response.data);
      })
      .catch((e: Error) => {
        console.error("Error al obtener supervisores", e);
      });
  }, []);


  
useEffect(() => {
    usuariosServices.getAllSupervisor().then((response) => {
        console.log("SUPERVISORES CARGADOS:", response.data); // <--- MIRA ESTO
        setSupervisores(response.data);
    });
}, []);




  useEffect(() => {
    if (!isNaN(IdUsuario)) {
      PerfilesMenuServices.getAllPerfiles()
        .then((response) => {
          setPerfiles(response.data);
        })
        .catch((e: Error) => { });
    }
  }, []);

  useEffect(() => {
    usuariosServices
      .getAllUsuariosShort()
      .then((response) => {
        setcomboUsuarios(response.data);
      })
      .catch((e: Error) => { });
  }, []);



  function currentDate(): string {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    return mm + "/" + dd + "/" + yyyy;
  }


  function toggleShowPerfil() {
    setToastPerfil(!toastPerfil);
  }

  function construyePerfil(values: IPerfil) {
    if (UsuariosPerfilesMenu) {
      console.log(UsuariosPerfilesMenu);
      var opcionesPerfil = UsuariosPerfilesMenu.filter(function (el) {
        return el.idPerfil == values.id;
      });
      setPerfilActual(opcionesPerfil);
    }
  }

  
  
// Estados para el nuevo flujo
const [modalConfiguracion, setModalConfiguracion] = useState(false);
const [idSupervisorNomina, setIdSupervisorNomina] = useState(0);
const [usuariosPorSupervisor, setUsuariosPorSupervisor] = useState<IRegister[]>([]); 




const finalizarConfiguracion = async () => {
    if (idSupervisorNomina === 0) {
        setmsgDialog("Debe seleccionar un responsable de nómina.");
        setShowDialog(true);
        return;
    }

    if (IdUsuario === 0) {
        setmsgDialog("Error: No se ha detectado el ID del usuario.");
        setShowDialog(true);
        return;
    }

    try {
        // AGREGAR soloLecturaNomina como 4to parámetro
        // await NominaServices.GestionarEmpleadoNomina(1, idSupervisorNomina, IdUsuario, soloLecturaNomina);
        
        await NominaServices.GestionarEmpleadoNomina(1, idSupervisorNomina, IdUsuario, false);
        setmsgDialog("Configuración de nómina finalizada con éxito.");
        setShowDialog(true);
        setModalConfiguracion(false); 
        setIdSupervisorNomina(0);
        setSoloLecturaNomina(false); // Resetear permiso

    } catch (error: any) {
        setmsgDialog("Error al asignar nómina: " + error.message);
        setShowDialog(true);
    }
};





function createUser(data: IRegister) {
    // Validamos que lleve perfil
    if(data.idPerfil === 0) {
        setmsgDialog("Por favor, seleccione un perfil antes de guardar.");
        setShowDialog(true);
        return;
    }

    usuariosServices.create(data).then((response) => {
        if (response.status === 200) {
            const usuarioCreado = (response.data as unknown) as IRegister;
            setIdUsuario(usuarioCreado.id);
            
            // Como el perfil YA SE GUARDÓ, el modal ahora solo 
            // se encarga de la parte de Nómina/Nominista
            setModalConfiguracion(true);
        }
    });
}












  const CloseModal = (show: boolean): void => {
    setModalUserList(false);
  };

  const CloseModalAP = (show: boolean): void => {
    setmodalAdmonPerfiles(false);
  };

  const CloseModalPerfiles = (show: boolean): void => {
    //setmodalAdmonPerfiles(false);
  };

  

const GetUserInfo = (data: IRegister): void => {
  setIdUsuario(data.id);
  setUsuario(data.usuario);
  setNombre(data.nombre);
  setContrasena(data.contrasena);
  setCorreo(data.correo);
  setIdPerfil(data.idPerfil);
  setTipoUsuario(data.tipoUsuario);
  setNumEmpleado(data.numEmpleado || "0");

  // CLAVE: Extraemos el ID que ya viene del backend
  const supervisorId = Number(data.idSupervisor) || 0;
  
  // Actualizamos el estado local
  setIdSupervisor(supervisorId); 
  
  // Actualizamos Formik manualmente para que no haya desfase
  // formik.setFieldValue("idSupervisor", supervisorId);

  console.log("Cargando supervisor con ID:", supervisorId);
};



  const clonaInformacion = (): void => {
    if (IdPerfil == 0) {
      setToastPerfil(true);
      setmsgDialog("");
      return;
    } else setShowConfirmation(true);
  };

  const ChangeUser2Clone = (e: any): void => {
    setUser2Clone(e.target.value);
    const usr = comboUsuarios.filter((item) => item.id == e.target.value);
    setUsuarioDestino(usr[0].usuario);
  };

  const handleClose = () => setShowConfirmation(false);

  const procedeClonacion = () => {
    const data: DTOClonarUsuario = {
      idUsuarioOrigen: IdUsuario,
      idUsuarioDestino: user2Clone,
    };
    usuariosServices
      .clonarUsuario(data)
      .then((response) => {
        if (response.status == 200) {
          setToastPerfil(true);
          setmsgDialog("Usuario clonado existosamente");
        }
      })
      .catch((e: Error) => {
        console.log(e);
      });
    setShowConfirmation(false);
  };

  const onChangePerfil = (e: any): void => {
    setIdPerfil(e.currentTarget.value);
  };

  return (
    <div className="container" style={{ paddingTop: "10px" }}>
      <div className="row">
        <div className="col">
          <Card>
            <Card.Body>

              
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={SignupSchema}
                onSubmit={(values, actions) => {
                  console.log(values, actions);
                  createUser(values);
                }}
              //  validate={validateForm}
              >
                {(formik) => {
                  const {
                    errors,
                    touched,
                    isValid,
                    dirty,
                    values,
                    handleSubmit,
                  } = formik;
                  return (
                    <Form
                      id="login-form"
                      className="form"
                      onSubmit={handleSubmit}
                    >
                      <Accordion defaultActiveKey="0">
                        <Accordion defaultActiveKey="0" className="shadow-sm border-0 mb-4">
  

                          <Accordion.Item eventKey="1" className="border-0">
                            <Accordion.Header className="bg-white custom-accordion-header">
                              <h5 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                <i className="bi bi-people-fill me-2 text-primary"></i>
                                Gestión de Supervisores y Movimientos
                              </h5>
                            </Accordion.Header>

                            <Accordion.Body className="p-4 bg-white">
                              
                              <ListarSupervisoresYMovimientos />
                            </Accordion.Body>
                          </Accordion.Item>

                          
                        </Accordion>


                       
                      
                       
                  


                        <Accordion.Item eventKey="0">
                          <Accordion.Header className="bg-white custom-accordion-header">
                          <h5 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                            <i className="bi bi-people-fill me-2 text-primary"></i>
                            Informacion Obligatoria
                          </h5>
                        </Accordion.Header>

                          <Accordion.Body>
                            <div className="row">
                              <div className="col">
                                <Button
                                  variant="primary"
                                  onClick={() => setModalUserList(true)}
                                >
                                  Ver usuarios
                                </Button>
                                <UserList
                                  show={modalUserList}
                                  CloseModal={CloseModal}
                                  GetUserInfo={GetUserInfo}
                                />
                              </div>
                              <div className="col">
                                <Button
                                  variant="btn btn-secondary"
                                  onClick={() => setmodalAdmonPerfiles(true)}
                                >
                                  Admon perfiles
                                </Button>
                                <div>
                                  <AdmonPerfiles
                                    show={modalAdmonPerfiles}
                                    CloseModal={CloseModalAP}
                                    CloseModalPerfiles={CloseModalPerfiles}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <div className="form-group">
                                  <div className="label">ID</div>
                                  <Field
                                    id="ID"
                                    name="ID"
                                    className="form-control"
                                    placeholder=""
                                    value={formik.values.id}
                                    disabled="disabled"
                                  />
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group">
                                  <label
                                    className="text-info"
                                    htmlFor="usuario"
                                    style={{ color: "#000000" }}
                                  >
                                    Usuario
                                  </label>
                                  {/* <Field
                                    id="usuario"
                                    name="usuario"
                                    className="form-control"
                                    placeholder="usuario"
                                  /> */}

                                  <Field
                                  name="usuario"
                                  id="usuario"
                                  className="form-control"
                                  placeholder="usuario"
                                  onChange={(e: React.ChangeEvent<any>) => {
                                    formik.handleChange(e);      // Esto actualiza el estado interno de Formik
                                    setUsuario(e.target.value);  // Esto actualiza tu estado local 'Usuario' para que 'initialValues' no se vacíe
                                  }}
                                />

                                  
                                  {errors.usuario && touched.usuario ? (
                                    <div>
                                      {" "}
                                      <span style={{ color: "#FF3346" }}>
                                        {" "}
                                        * {errors.usuario}{" "}
                                      </span>{" "}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <div className="form-group">
                                  <label
                                    className="text-info"
                                    htmlFor="Nombre"
                                    style={{ color: "#572364" }}
                                  >
                                    
                                    Nombre
                                  </label>
                                  

                                  <Field
  name="nombre"
  id="nombre"
  className="form-control"
  placeholder="nombre"
  onChange={(e: React.ChangeEvent<any>) => {
    formik.handleChange(e);
    setNombre(e.target.value); // Mantiene sincronizado tu const [Nombre, setNombre]
  }}
/>
                                  {errors.nombre && touched.nombre ? (
                                    <div>
                                      {" "}
                                      <span style={{ color: "#FF3346" }}>
                                        {" "}
                                        * {errors.nombre}{" "}
                                      </span>{" "}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group">
                                  <label
                                    className="text-info"
                                    htmlFor="password"
                                  >
                                    Contraseña
                                  </label>
                                  <Field
                                    id="contrasena"
                                    name="contrasena"
                                    className="form-control"
                                    placeholder="contraseña"
                                    type="password"
                                    disabled="diabled"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <div className="form-group">
                                  <label className="text-info" htmlFor="correo">
                                    Correo
                                  </label>
                                  {/* <Field
                                    id="correo"
                                    name="correo"
                                    className="form-control"
                                    placeholder="correo"
                                  /> */}

                                  <Field
  name="correo"
  id="correo"
  className="form-control"
  placeholder="correo"
  onChange={(e: React.ChangeEvent<any>) => {
    formik.handleChange(e);
    setCorreo(e.target.value);
  }}
/>
                                  {errors.correo && touched.correo ? (
                                    <span style={{ color: "#FF3346" }}>
                                      {" "}
                                      <div>* {errors.correo}</div>{" "}
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group">
                                  <label
                                    className="text-info"
                                    htmlFor="tipousuario"
                                  >
                                    Tipo usuario
                                  </label>
                                  <FormCtrl.Control
                                    as="select"
                                    id="tipousuario"
                                    name="tipousuario"
                                    value={formik.values.tipoUsuario}
                                    onChange={(e) =>
                                      setTipoUsuario(parseInt(e.target.value))
                                    }
                                    className="form-select form-select-sm"
                                  >
                                    <option value="1">Administrador</option>
                                    <option value="2">Operacional</option>
                                    {/* <option value='3'>GEMCO</option>
                                    <option value='4'>BROKER</option> */}
                                  </FormCtrl.Control>
                                </div>
                              </div>
                            </div>


                                    <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <label className="text-primary fw-bold">Asignar Perfil de Acceso</label>
              <FormCtrl.Control
                as="select"
                value={formik.values.idPerfil}
                onChange={(e) => {
                  const val = parseInt(e.target.value);
                  setIdPerfil(val);
                  formik.setFieldValue("idPerfil", val);
                }}
              >
                <option value={0}>-- Seleccione un perfil --</option>
                {perfiles.map((p) => (
                  <option key={p.id} value={p.id}>{p.perfil}</option>
                ))}
              </FormCtrl.Control>
            </div>
          </div>
        </div>


                            <div className="row">
                              <div className="col">
                                <div className="form-group">
                                  <label className="text-info" htmlFor="activo">
                                    Activo
                                  </label>
                                  <Field
                                    as="select"
                                    name="activo"
                                    className="form-control"
                                  >
                                    <option value="1">Activo</option>
                                    <option value="0">Inactivo</option>
                                  </Field>
                                </div>
                              </div>
                              <div className="col">
                                {" "}
                                <div className="form-group">
                                  <label
                                    className="text-info"
                                    htmlFor="fechaAlta"
                                  >
                                    Fecha alta
                                  </label>
                                  <Field
                                    id="fechaAlta"
                                    name="fechaAlta"
                                    readOnly="readOnly"
                                    className="form-control"
                                    placeholder="fecha alta"
                                    defaultValue={currentDate()}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <div className="form-group">
                                  <label
                                    className="text-info"
                                    htmlFor="usuarioAlta"
                                  >
                                    Usuario alta
                                  </label>
                                  <Field
                                    as="select"
                                    name="usuarioAlta"
                                    className="form-control"
                                  >
                                    <option value={IdUsuario}>
                                      {getUsuario()}
                                    </option>
                                  </Field>
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-group">
                                  <label
                                    className="text-info"
                                    htmlFor="fechaModifico"
                                  >
                                    Fecha modifico
                                  </label>
                                  <Field
                                    id="fechaModifico"
                                    name="fechaModifico"
                                    readOnly="readOnly"
                                    className="form-control"
                                    placeholder="Fecha modifico"
                                    defaultValue={currentDate()}
                                  />
                                </div>
                              </div>

                              <div className="col">
  <label className="text-info" htmlFor="NumEmpleado">
    Num Empleado
  </label>
  <Field
    id="NumEmpleado"
    name="numEmpleado"
    className="form-control"
    placeholder="NúmEmpleado"
    // EL CAMBIO ESTÁ AQUÍ:
    value={formik.values.numEmpleado} 
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      formik.setFieldValue("numEmpleado", val); // Actualiza Formik
      setNumEmpleado(val); 
    }}
  />
</div>

                              <div className="row">
                                <div className="col">
                                  <div className="form-group">
                                    <label
                                      className="text-info"
                                      htmlFor="idSupervisor"
                                    >
                                      Seleccionar Supervisor Permisos - Vacaciones 
                                    </label>
                                  
                                    
                                   <FormCtrl.Control
                                as="select"
                                name="idSupervisor"
                                className="form-control"
                              
                                value={IdSupervisor} 
                                onChange={(e) => {
                                  const val = parseInt(e.target.value) || 0;
                                  setIdSupervisor(val);
                                  formik.setFieldValue("idSupervisor", val);
                                }}
                              >
                                <option value={0}>
                                                                      - Seleccione un Supervisor -
                                                                    </option>
                                                                    {supervisores.map((supervisor) => (
                                                                      <option
                                                                        key={supervisor.idSupervisor}
                                                                        value={supervisor.idSupervisor}
                                                                      >
                                                                        {supervisor.idSupervisor} -{" "}
                                                                        {supervisor.nombre} |{" "}
                                                                        {supervisor.correo}
                                                                      </option>
                                ))}
                              </FormCtrl.Control>
                                  </div>

                                  
                                </div>
                              </div>






                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>


                      
                      <div className="row">
                        <br />
                      </div>
                      <div className="row">
                        <div className="col"></div>
                        <div className="col"></div>
                        <div className="col">
                          <button
                            type="submit"
                            className="btn btn-primary btn-lg btn-block"
                          >
                            Guardar
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </Card.Body>
          </Card>
        </div>




        <div className="col">
          <Card style={IdUsuario > 0 ? {} : { display: "none" }}>
            <Card.Body>
              <div className="row">
                <div className="col">
                  <div className="row">
                    <div className="form-group">
                      <Alert variant="primary">
                        <Alert.Heading>
                          Seleccione el perfil que utilizara el usuario
                        </Alert.Heading>
                      </Alert>
                      <br />
                      <div className="form-group col-md-12">
                        <Formik
                          initialValues={initialValuesPerfiles}
                          onSubmit={(values: any, actions: any) => {
                            console.log({ values, actions });
                            construyePerfil(values);
                            actions.setSubmitting(false);
                          }}
                        >
                          <Form id="FrmPerfiles" className="form">
                            <div className="form-group">
                              <Field
                                as="select"
                                id="id"
                                name="id"
                                className="form-select form-select-sm"
                                placeholder="Perfil"
                                value={IdPerfil}
                                onChange={onChangePerfil}
                              >
                                {perfiles.map((p) => {
                                  return (
                                    <option value={p.id}>{p.perfil}</option>
                                  );
                                })}
                              </Field>
                            </div>
                            <br />
                            
                          </Form>
                          
                        </Formik>
                        <div className="form-text mt-2 small">Define qué menús podrá ver el usuario.</div>
                      </div>
                    </div>
                  </div>
                </div>

                
              </div>
              <br />
              


              
              <ToastContainer position="middle-center">
                <Toast show={toastPerfil} onClose={toggleShowPerfil}>
                  <Toast.Header>
                    <strong className="me-auto">Error!</strong>
                  </Toast.Header>
                  <Toast.Body>
                    Seleccione un perfil, para poder continuar...
                  </Toast.Body>
                </Toast>
              </ToastContainer>
            </Card.Body>
          </Card>
        </div>
      </div>
      <ToastContainer position={"middle-center"}>
        <Toast
          onClose={() => setShowDialog(false)}
          show={showDialog}
          delay={3000}
          bg="dark"
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Informacion</strong>
          </Toast.Header>
          <Toast.Body style={{ backgroundColor: "#F8F9F9" }}>
            {msgDialog}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Modal show={showConfirmation} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Favor de confirmar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Esta seguro de que desea clonar la informacion de : <br />[ {Usuario}{" "}
          ] para ... [ {usuarioDestino} ] ?
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col">
              <Button variant="secondary" onClick={handleClose}>
                No
              </Button>
            </div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col">
              <Button variant="primary" onClick={procedeClonacion}>
                Si
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>


         <Modal 
    show={modalConfiguracion} 
    onHide={() => setModalConfiguracion(false)} 
    centered 
    backdrop="static" 
    size="lg"
>
    <Modal.Header className="border-0 pt-4 px-4 bg-white">
        <Modal.Title className="fw-bold text-dark">
            <i className="bi bi-shield-check text-primary me-2"></i>
            Configuración Final de Acceso
        </Modal.Title>
    </Modal.Header>
    
    <Modal.Body className="px-4 pb-4">
        <p className="text-muted mb-4">Complete los datos obligatorios para el usuario: <strong className="text-dark">{Nombre || Usuario}</strong></p>
        
        <div className="row g-4">
            <div className="col-md-6">
                <label className="form-label small fw-bold text-uppercase text-muted">Responsable de Nómina</label>
                <FormCtrl.Select
                    value={idSupervisorNomina}
                    onChange={(e) => setIdSupervisorNomina(parseInt(e.target.value))}
                    className="form-select-lg border-2 border-primary shadow-none"
                >
                    <option value={0}>-- Seleccione Supervisor  Nominista --</option>
                    {supervisores
                        .filter(s => s.esNominista === 1) // Solo mostramos los autorizados
                        .map((s) => (
                            <option
                                          key={s.idSupervisor}
                                          value={s.idSupervisor}
                                        >
                                          {s.idSupervisor} -{" "}
                                          {s.nombre} |{" "}
                                          {s.correo}
                                        </option>
                        ))
                    }
                </FormCtrl.Select>
                <div className="form-text mt-2 small text-primary fw-medium">
                    <i className="bi bi-info-circle me-1"></i>
                    Supervisor que procesará su pago semanal.
                </div>
            </div>
        </div>
    </Modal.Body>

    <Modal.Footer className="border-0 p-4 bg-light bg-opacity-50">
        <Button variant="outline-secondary" className="rounded-pill px-4" onClick={() => setModalConfiguracion(false)}>
            Configurar después
        </Button>
        <Button variant="primary" className="rounded-pill px-5 fw-bold shadow-sm" onClick={finalizarConfiguracion}>
            Guardar y Finalizar <i className="bi bi-arrow-right ms-2"></i>
        </Button>
    </Modal.Footer>
</Modal>











    </div>
  );
}
